<template>
  <div class="overview-app">
    <a href="#overview-main" class="skip-overview">Skip to dashboard</a>
    <aside class="overview-sidebar">
      <router-link to="/" class="overview-brand" aria-label="PacSort Analytics home">
        <img src="@/assets/images/login-brand/mark.svg" width="44" height="44" alt="" /><span>PacSort<small>ANALYTICS</small></span>
      </router-link>
      <p class="nav-label">WORKSPACE</p>
      <nav aria-label="Main navigation" class="overview-nav">
        <router-link to="/" exact-active-class="selected">
          <i class="mdi mdi-view-dashboard-outline" aria-hidden="true"></i>Overview
        </router-link>
        <router-link to="/shipments" exact-active-class="selected">
          <i class="mdi mdi-package-variant-closed" aria-hidden="true"></i>Shipments
        </router-link>
        <router-link to="/assignments" exact-active-class="selected">
          <i class="mdi mdi-clipboard-text-outline" aria-hidden="true"></i>Assignments
        </router-link>
        <router-link to="/customers" exact-active-class="selected">
          <i class="mdi mdi-account-group-outline" aria-hidden="true"></i>Customers
        </router-link>
      </nav>
      <div class="sidebar-bottom">
        <a href="mailto:support@21grams.com"><i class="mdi mdi-help-circle-outline" aria-hidden="true"></i>Help & support</a><a href="https://pacsortonline.com/">PacSort Online <span aria-hidden="true">↗</span></a><img src="@/assets/images/login-brand/wordmark.svg" width="88" height="23" alt="21grams" />
      </div>
    </aside>
    <div class="overview-workspace">
      <header class="overview-topbar">
        <span class="breadcrumb-label">Workspace <span>/</span> <strong>{{ title }}</strong></span><span v-if="demo" class="demo-badge">Preview · sample data</span><router-link to="/logout" class="direct-logout" :aria-label="`Log out ${name}`" :title="`Log out ${name}`">
          <span class="avatar" aria-hidden="true">{{ initial }}</span>
          <span class="logout-name">{{ name }}</span>
          <span class="logout-label">Log out</span>
          <i class="mdi mdi-logout" aria-hidden="true"></i>
        </router-link>
      </header>
      <main id="overview-main" class="overview-main">
        <slot />
        <footer class="overview-footer">
          <span>© {{ new Date().getFullYear() }} 21grams</span><span v-if="demo">Sample values for design review. Not live operational data.</span><a href="mailto:support@21grams.com">Contact support <span aria-hidden="true">↗</span></a>
        </footer>
      </main>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useAuthStore } from '@/requests/Auth'
withDefaults(defineProps<{ title?: string }>(), { title: 'Overview' })
const demo = import.meta.env.DEV && import.meta.env.VITE_USE_API_MOCKS === 'true'
const user = useAuthStore().getCurrentUser()
const name = demo ? 'Demo workspace' : user?.firstName || user?.email || 'Account'
const initial = name.charAt(0).toUpperCase()
</script>
<style scoped src="./overview.css"></style>
<style scoped src="./reports.css"></style>

<style scoped>
.direct-logout{display:inline-flex;align-items:center;gap:9px;min-height:44px;padding:5px 10px;border:1px solid #d5e1da;border-radius:7px;background:#fff;color:#284c44;font-size:14px;text-decoration:none;flex-shrink:0}
.direct-logout:hover{background:#edf5ef;border-color:#96b4a3}
.logout-name{max-width:190px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.logout-label{border-left:1px solid #d5e1da;padding-left:10px;white-space:nowrap}
.direct-logout>i{font-size:18px}
@media(max-width:560px){.overview-topbar{flex-wrap:wrap;height:auto;min-height:60px;padding-top:8px;padding-bottom:8px}.breadcrumb-label{display:none}.demo-badge{margin-right:auto}.direct-logout{gap:6px;padding:4px 7px;font-size:12px}.direct-logout .avatar{width:26px;height:26px;font-size:12px}.logout-name{max-width:100px}.logout-label{padding-left:7px}}
</style>
